import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { withBem } from "../hocs";
import SvgIcon from "./svg-icon";
import rightArrowIcon from "assets/icons/arrow-right.svg";
import leftArrowIcon from "assets/icons/arrow-left.svg";

const ProjectNavLink = ({
  direction,
  to,
  cn,
  className,
  children,
  ...rest
}) => {
  const arrow = (
    <SvgIcon
      symbol={direction === "right" ? rightArrowIcon : leftArrowIcon}
      className={cn(`arrow-${direction}`)}
    />
  );
  if (to) {
    return (
      <Link {...rest} to={to} className={classnames(cn())}>
        {direction === "left" && arrow}
        {children}
        {direction === "right" && arrow}
      </Link>
    );
  } else {
    return (
      <a {...rest} className={classnames(cn())}>
        {direction === "left" && arrow}
        {children}
        {direction === "right" && arrow}
      </a>
    );
  }
};

export default withBem("link-with-arrow")(ProjectNavLink);
